export const setStorage = (path, data) => {
  localStorage.setItem(path, JSON.stringify(data));
};

export const getStorage = (path) => {
  try {
    const item = localStorage.getItem(path);
    return item ? JSON.parse(item) : null;
  } catch (error) {
    console.warn(`Failed to parse localStorage item "${path}":`, error);
    return null;
  }
};

export const removeStorage = (path) => {
  localStorage.removeItem(path);
};

export const clearStorage = () => {
  localStorage.clear();
};
